import React, { useState } from "react";
import { LuChevronDown } from "react-icons/lu";

export const AccountSettingsComponent = () => {
  const [turnGreen, setTurnGreen] = useState(false);
  return (
    <div className="w-full lg:w-3/4 lg:px-6 lg:py-10">
      <h1 className="font-semibold text-[28px] md:text-[32px]">Account Settings</h1>
      <p className="py-2 font-extralight text-lg">
        Manage your Mobile Page Flows experience
      </p>
      <div className="dark:bg-[#282828] bg-[#F0F0F0] p-6 rounded-lg w-full">
      <div className="py-4 items-center flex space-x-4">
        <img
          className=" rounded-full object-cover w-16 h-16 dark:border-gray-600"
          src="https://images.pexels.com/photos/91227/pexels-photo-91227.jpeg?auto=compress&cs=tinysrgb&w=800"
          alt=""
        />
        <button className="rounded-lg  border border-[#d3d3d3] px-3 py-1 bg-transparent dark:border-gray-600 ">
          Upload New Image
        </button>
        <button className="rounded-lg px-3 py-1 bg-[#FAEBEB] border bg-transparent border-[#ef4646] text-[#EF4646] dark:bg-transparent dark:border-[#EF4646] ">
          Delete
        </button>
      </div>
      <div>
        <label htmlFor="email">Email Address</label>
        <br />
        <input
          className="bg-white dark:border-gray-600 my-2 w-full  rounded-lg border px-4 py-3 bg-transparent dark:bg-[#1C1C1C]"
          name="email"
          type="email"
          placeholder="christine.smith@company.com"
        />
        <br />
        <label htmlFor="Name">First & Last Name</label>
        <br />
        <input
          className="bg-white dark:border-gray-600 my-2 w-full  rounded-lg border px-4 py-3 bg-transparent dark:bg-[#1C1C1C]"
          name="Name"
          type="text"
          placeholder="christine Smith"
        />
        <div className="w-full  flex-col lg:flex-row flex items-center lg:space-x-2">
          <div className="relative w-full">
            <label htmlFor="Country">Country</label>
            <br />
            <select
              name="countries"
              className="custom-select bg-white dark:border-gray-600 my-2 w-full rounded-lg border px-4 py-3 bg-transparent dark:bg-[#1C1C1C]"
              id="countries"
            >
              <option value="Romania">Romania</option>
              <option value="Romania">Romania</option>
              <option value="Romania">Romania</option>
              <option value="Romania">Romania</option>
            </select>
            <LuChevronDown className='text-xl  absolute right-2 top-12'/>
          </div>
          <div className="w-full">
            <label htmlFor="City">City</label>
            <br />
            <input
              className="bg-white dark:border-gray-600  my-2 w-full rounded-lg border px-4 py-3 bg-transparent dark:bg-[#1C1C1C]"
              name="City"
              type="text"
              placeholder="Romania"
            />
          </div>
        </div>
      </div>
      </div>
      <div className="bg-[#f0f0f0] dark:bg-[#282828] p-6 rounded-lg w-full my-4">
      <h1 className="font-semibold text-[28px]">Password</h1>
      <p className="py-2 font-extralight">
        You can set a permanent password if you don't want to use temporary
        login codes.
      </p>

      <div className="pb-4">
        <label htmlFor="Password">Current Password</label>
        <br />
        <input
          className="bg-white dark:border-gray-600 dark:bg-[#1C1C1C] my-2 w-full  rounded-lg border px-4 py-3 bg-transparent"
          name="password"
          type="password"
          placeholder="........"
        />
        <br />
        <label htmlFor="Newpass">New Password</label>
        <br />
        <input
          className="bg-white dark:border-gray-600 dark:bg-[#1C1C1C] my-2 w-full  rounded-lg border px-4 py-3 bg-transparent"
          name="Newpass"
          type="text"
          placeholder="You can set a permanent password if you don't want to use temporary login codes."
        />
        <br />
        <p className={false ? "hidden" : "text-gray-400"}>
            Must be 8-25 characters and contain numbers and letters.
          </p>
          <div
            className={false ? "hidden" : "flex items-center space-x-2 py-5"}
          >
            <div
              className={
                turnGreen
                  ? "w-full h-[3px] rounded bg-green-500"
                   : "w-full h-[3px] rounded bg-[#d3d3d3] dark:bg-[#5B5B5B]"
              }
            />
            <div
              className={
                turnGreen
                  ? "w-full h-[3px] rounded bg-green-500"
                   : "w-full h-[3px] rounded bg-[#d3d3d3] dark:bg-[#5B5B5B]"
              }
            />
            <div
              className={
                turnGreen
                  ? "w-full h-[3px] rounded bg-green-500"
                     : "w-full h-[3px] rounded bg-[#d3d3d3] dark:bg-[#5B5B5B]"
              }
            />
            <div
              className={
                turnGreen
                  ? "w-full h-[3px] rounded bg-green-500"
                : "w-full h-[3px] rounded bg-[#d3d3d3] dark:bg-[#5B5B5B]"
              }
            />
            <div
              className={
                turnGreen
                  ? "w-full h-[3px] rounded bg-green-500"
                    : "w-full h-[3px] rounded bg-[#d3d3d3] dark:bg-[#5B5B5B]"
              }
            />
          </div>
        <label htmlFor="Confirmpass">Confirm New Password</label>
        <br />
        <input
          className="bg-white dark:border-gray-600 dark:bg-[#1c1c1c] my-2 w-full  rounded-lg border px-4 py-3 bg-transparent"
          name="Newpass"
          type="text"
          placeholder="placeholder"
        />
        </div>
      </div>
        
        <button className=" md:w-fit px-4 py-2 bg-black rounded-xl text-white text-lg dark:bg-white dark:text-black">
          Save
        </button>
     
      <div className="bg-[#f0f0f0] dark:bg-[#282828] p-6 rounded-lg w-full mt-4">
  
        <h1 className="font-semibold text-[28px]">Delete account</h1>
        <p className="py-2 font-extralight">
          Permanently delete your account and all of your content.
        </p>
        <button className="w-fit rounded-lg px-3 py-2 bg-[#EF4646] text-white">
          Delete
        </button>
      </div>
    </div>
  );
};
